// extracted by mini-css-extract-plugin
export var search_card = "styles-module--search_card--86cd1";
export var title = "styles-module--title--30eb9";